<!--
Author:
Description: 房产客户关系选择框
-->
<template>
  <div class="com-houseregis-select">
      <span>
        <el-input
          placeholder
          v-model="label"
          @focus="handleInputClick"
          :disabled="disabled"
          data-ignore-clearable="true"
          data-ignore-at-clear="handleClear"
          :title="label"
        >
        <i
          class="el-icon-search el-input__icon"
          slot="suffix">
        </i></el-input>
      </span>

      <houseRegisRef
        ref="houseRegisRef"
        :visible="isHouseRegisRefVisible"
        @confirm="handleHouseRegisRefConfirm"
        :multiple="multiple"
        @cancel="handleHouseRegisRefCancel"
        append-to-body
        width="65%"
      />
  </div>
</template>

<script>
export default {
  name: 'houseRegisSelect',
  props: {
      value: {
          type: [String, Array, undefined],
          default: () => ''
      },
      label: {
          type: String,
          default: () => ''
      },
      disabled: {
          type: Boolean,
          default: () => false
      },
  },
  data () {
    return {
        isHouseRegisRefVisible: false,
    }
  },
  computed: {
      multiple() {
          return Array.isArray(this.value);
      },
  },
  methods: {
      handleInputClick() {
          this.isHouseRegisRefVisible = true;
      },
      handleClear() {},
      handleHouseRegisRefConfirm(value) {
          let val = Array.isArray(value) ? value.map(o => o.id) : value.id;
          this.$emit('update:value', val, value);
          this.$emit('change', val, value);
          this.$emit('input', val, value);
          this.isHouseRegisRefVisible = false;
      },
      handleHouseRegisRefCancel() {
          this.isHouseRegisRefVisible = false;
      },
  }
}
</script>

<style scoped lang="less">
.com-houseregis-select {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/houseRegis/houseRegisSelect.vue